import type { GetCollectionOrderReportsParams } from 'api';

import type { GlobalFiltersState } from 'reduxLocal/slices/globalFiltersSlice';

import type { LocalState } from './localState';

export type Params = LocalState & GlobalFiltersState;

export const apiParams = function (
  state: Partial<Params>
): GetCollectionOrderReportsParams {
  const params: GetCollectionOrderReportsParams = {};

  if (
    state.filters?.virtualAccountNumber &&
    state.filters.virtualAccountNumber !== 'All'
  ) {
    params['filter[virtual_account_number]'] =
      state.filters.virtualAccountNumber;
  }
  if (state.dateRange?.from) params['filter[date_from]'] = state.dateRange.from;
  if (state.dateRange?.to) params['filter[date_to]'] = state.dateRange.to;
  if (state.cursorAfter) params['page[cursor_after]'] = state.cursorAfter;
  if (state.cursorBefore) params['page[cursor_before]'] = state.cursorBefore;

  return params;
};
